import productRepository from './productRepository';
import customerRepository from './customerRepository';
import userRepository from './userRepository';
import orderRepository from './orderRepository';
import validationRepository from './validationRepository';
import securityRepository from './securityRepository';
import VirtualCardRepository from './virtualCardRepository';

const repositories = {
  products: productRepository,
  customer: customerRepository,
  user: userRepository,
  order: orderRepository,
  validation: validationRepository,
  security: securityRepository,
  virtualCard: VirtualCardRepository,
};

export const RepositoryFactory = {
  get: name => repositories[name],
};
